import React from "react";
import ModalFormUI from "../../../widgets/form/ModalFormUI";
import InputTextSF from "../../../widgets/form/InputTextSF";
import InputSelectSF from "../../../widgets/form/InputSelectSF";

const CustomerUpdateModalUI = ({ context, successMsg, errorList, setErrorList, onUpdateClick,
  updateMode, submitted, onCancelUpdate, contactFirstName, onContactFirstNameChange, contactFirstNameError,
  setContactFirstNameError, contactLastName, onContactLastNameChange, setContactLastNameError, contactLastNameError,
  contactPhone, onContactPhoneChange, setContactPhoneError, contactPhoneError, contactEmail, onContactEmailChange,
  setContactEmailError, contactEmailError,
  state, stateList, onStateChange, setStateError, stateError, city, onCityChange, setCityError, cityError, postalCode,
  onPostalCodeChange, setPostalCodeError, postalCodeError, streetAddress, onStreetAddressChange, setStreetAddressError,
  streetAddressError, CollectionDueInDays, onCollectionDueInDaysChange, setCollectionDueInDaysError, CollectionDueInDaysError,
  enableEscrow, onEnableEscrowChange, enableEscrowError, setEnableEscrowError
}) => {

  const escrowOptions = [
    { key: true, value: "Yes" },
    { key: false, value: "No" }
  ];

  return (
    <ModalFormUI
      context={context}
      titleLabel='Update customer'
      buttonLabel='Update customer'
      cancelLabel='Cancel'
      isOpen={updateMode}
      onRequestClose={onCancelUpdate}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onUpdateClick}
      busy={submitted}
    >
      <div className='g_flex_h g_flex_top'>
        <div className='col'>
          <InputTextSF type='text' name='s_firstName' maxLength={12}
            label='Contact first name' autoFocus={true}
            value={contactFirstName} onChange={onContactFirstNameChange}
            error={contactFirstNameError} setError={setContactFirstNameError}
          />
          <InputTextSF type='text' name='s_LastName' maxLength={12}
            label='Contact last name' autoFocus={true}
            value={contactLastName} onChange={onContactLastNameChange}
            error={contactLastNameError} setError={setContactLastNameError}
          />
          <InputTextSF type='text' name='s_phone' maxLength={12}
            label='Phone number' autoFocus={true}
            value={contactPhone} onChange={onContactPhoneChange}
            error={contactPhoneError} setError={setContactPhoneError}
          />
          <InputTextSF type='text' name='s_email' maxLength={100}
            label='Email' autoFocus={true}
            value={contactEmail} onChange={onContactEmailChange}
            error={contactEmailError} setError={setContactEmailError}
          />
          <InputSelectSF name='enable_escrow'
            label='Enable Escrow'
            value={enableEscrow}
            onChange={onEnableEscrowChange}
            optionList={escrowOptions}
            error={enableEscrowError}
            setError={setEnableEscrowError}
          />
        </div>
        <div className='g_m_left_100'>
          <InputTextSF type='text' name='s_streetAddress' maxLength={12}
            label='Address' autoFocus={true}
            value={streetAddress} onChange={onStreetAddressChange}
            error={streetAddressError} setError={setStreetAddressError}
          />
          <InputSelectSF type='select' name='state' required={true}
            label='State'
            value={state} onChange={onStateChange} optionList={stateList}
            error={stateError} setError={setStateError}
          />
          <InputTextSF type='text' name='s_city' maxLength={12}
            label='City' autoFocus={true}
            value={city} onChange={onCityChange}
            error={cityError} setError={setCityError}
          />
          <InputTextSF type='text' name='s_postalCode' maxLength={12}
            label='Postal code' autoFocus={true}
            value={postalCode} onChange={onPostalCodeChange}
            error={postalCodeError} setError={setPostalCodeError}
          />
          <InputTextSF type='text' name='s_CollectionDueInDays' maxLength={4}
            label='Collection due in days' autoFocus={true}
            value={CollectionDueInDays} onChange={onCollectionDueInDaysChange}
            error={CollectionDueInDaysError} setError={setCollectionDueInDaysError}
          />
        </div>
      </div>
    </ModalFormUI>
  );
}

export default CustomerUpdateModalUI;